import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** The value stack — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-133" data-mp="1fmw5hbui9ams">
      <div className="mx-auto max-w-5xl" data-id="element-134" data-mp="28a9umnryp1wc">
        <SectionHeading id="offer-heading" title={<>
              Le tue prossime lezioni possono essere <Accent data-id="element-136" data-mp="1yjxcf27mdktd">più semplici da preparare.</Accent>
            </>} body="Ottieni Lash & Brow Instructor Ready™ — Versione Italiana e inizia a organizzare i tuoi corsi con materiali già strutturati." data-id="element-135" data-mp="28bkx8k9o83lv" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-champagne/60 bg-white shadow-[0_50px_100px_-50px_rgba(180,86,111,0.45)]" data-id="element-137" data-mp="2r7b1yf8zne3g">
          <div className="bg-brand-charcoal px-6 py-4 text-center" data-id="element-138" data-mp="3hh4mv3rifkog">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-139" data-mp="33pgdh88nbab6">
              Sistema completo · Versione Italiana
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-140" data-mp="37op5o8o1f04m">
            <img src={MOCKUP_URL} alt="Tutto ciò che è incluso in Lash & Brow Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[580px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(180, 86, 111, 0.16))'
          }} data-id="element-141" data-mp="2tq904l1wvfo2" />

            <ul className="mx-auto mt-10 grid max-w-xl gap-3.5 sm:grid-cols-2" role="list" data-id="element-142" data-mp="j0k8i5276u4u">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-143" data-mp="myhyha3slk9a">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-144" data-mp="1qy6humqxwzyz" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex items-baseline justify-center gap-3 border-y border-brand-charcoal/10 py-6" data-id="element-145" data-mp="1hyjehvenhk3a">
              <span className="font-display text-[3rem] font-bold leading-none text-brand-rosewood" data-id="element-146" data-mp="2en7jnr59pcva">11</span>
              <span className="font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-charcoal" data-id="element-147" data-mp="2anyqooi1xj0s">
                Risorse didattiche digitali
              </span>
            </div>

            <CtaBlock label="Sì, voglio il sistema completo!" showPrice className="mt-9" data-id="element-148" data-mp="20vsxjbg2cvk0" />
            <p className="mt-4 text-center font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-149" data-mp="2ydba0h73f7gt">
              Prodotto digitale. Nessuna spedizione fisica.
            </p>
          </div>
        </div>
      </div>
    </section>;
}